const featureToggles = {
  // Allow-list of user IDs who see gated features on production while the
  // global toggle is still off (e.g. PAYG).
  featureFlagOverrideUserIds: [2, 341236, 492347],
  // PAYG credit purchase on pricing page (TP-187). When true and TEST_START_DATE has passed,
  // users are split A/B: even user IDs = control (PAYG hidden), odd = treatment (PAYG visible).
  paygCreditsPricingPage: false,
};

export default featureToggles;
